import { TalesTournament } from "../../../utils/types/TalesTournament";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { db, storage } from "../../../firebase/config";
import firebase from "firebase";
import FieldValue = firebase.firestore.FieldValue;

export const addTournament = createAsyncThunk(
  "tournament/add",
  async (tournament: TalesTournament) => {
    try {
      const file = tournament.file;
      let fileDownloadUrl;
      if (file) {
        const storageRef = storage.ref("tournament");
        const prova = await storageRef
          .child(file.name ?? "logo_image.jpg")
          .put(file);
        fileDownloadUrl = await prova.ref.getDownloadURL();
      }

      return db.collection("tournament").add({
        ...tournament,
        logoUrl: fileDownloadUrl,
        file: null,
        show: `${tournament.show}` === "true",
        creationDate: FieldValue.serverTimestamp(),
      });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Torneo non aggiunto, ${e.message}`);
    }
  },
);
